<template>
  <nav class="navbar navbar-inverse navbar-fixed-top style">
    <div class="container-fluid col-sm-12 col-md-12 col-xs-12">
      <div class="navbar-header">
        <img :src="img1" height="55" width="auto" />
      </div>

      <ul class="nav navbar-nav navbar-right hidden-sm-and-down"></ul>
    </div>
  </nav>
</template>

<script>
import icono from "../../assets/LOGO USACH.png";

export default {
  data() {
    return {
      img1: icono
    };
  }
};
</script>

<style scoped>
.style {
  background: white;
  border-top: 3px solid #5dabd8;
  border-bottom: 7px solid #b1b1b1;
  background-color: #1c345d !important;

  height: 70px;
}

.img-style {
  text-align: right;
}
</style>




// WEBPACK FOOTER //
// src/components/template/TopBar.vue